import styled from "styled-components";

import { Button as FormButton } from "@/components/Form/Button";
import { IThemeProps } from "@/styles";

// Compact, theme-driven card: sized to the registration overlay (no fixed max-width),
// tight spacing, and the same button as the form's own submit — BILD CI, not a bespoke look.
export const Card = styled.div<IThemeProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(props) => props.theme.spacing.desktop.s200}px;
  width: 100%;
  box-sizing: border-box;
  margin: ${(props) => props.theme.spacing.desktop.s200}px 0 0;
  padding: ${(props) => props.theme.spacing.desktop.s300}px;
  background: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.borderGrey};
  border-radius: 8px;
  text-align: center;

  @media ${(props) => props.theme.breakpoints.mobile} {
    padding: ${(props) => props.theme.spacing.desktop.s200}px;
  }
`;

export const ImageBox = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  img,
  svg {
    display: block;
    width: auto;
    height: 64px;
    max-width: 100%;
    object-fit: contain;
  }
`;

export const Title = styled.h4<IThemeProps>`
  margin: 0;
  font-size: ${(props) => props.theme.typography.h600};
  font-weight: 700;
  line-height: 1.3;
  color: ${(props) => props.theme.colors.fontText};
  overflow-wrap: break-word;
`;

export const Body = styled.p<IThemeProps>`
  margin: 0;
  max-width: 420px;
  font-size: ${(props) => props.theme.typography.h400};
  line-height: 1.45;
  color: ${(props) => props.theme.colors.fontTextSemiLight};
`;

// Rendered `as="a"`: identical look/hover to the form's submit button, link semantics kept.
export const Button = styled(FormButton)`
  margin: 0;
  padding: 10px 16px;
  box-sizing: border-box;
  height: auto;
  min-height: 41px;
  line-height: 1.25;
  text-decoration: none;
`;
